import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/PathwayComponent.css';
import RightSidebar from './RightSidebar';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const PathwayComponent = () => {
  const [pathways, setPathways] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedPathway, setSelectedPathway] = useState(null);
  const [pathwayFormat, setPathwayFormat] = useState('');
  const itemsPerPage = 5;
  const navigate = useNavigate();

  useEffect(() => {
    fetchPathways(currentPage);
  }, [currentPage]);

  const fetchPathways = async (page = 1) => {
    setLoading(true);
    try {
      const res = await axios.get(`http://197.156.76.122/api/pathway/?page=${page}`);
      const results = res.data.results || [];
      setPathways(results);

      // If API provides total count use it, otherwise derive from current page * itemsPerPage
      const totalItems = res.data.count !== undefined ? res.data.count : results.length;
      setTotalCount(totalItems);
      setTotalPages(Math.ceil(totalItems / itemsPerPage));
    } catch (e) {
      console.error('❌ Failed to fetch pathways', e);
      setPathways([]);
      setTotalCount(0);
      setTotalPages(1);
    }
    setLoading(false);
  };

  const handlePathwayDownload = () => {
    if (pathwayFormat) {
      const formatMap = {
        xml: 'pathway.xml',
        json: 'pathway.json',
        csv: 'pathway.csv',
      };
      const filename = formatMap[pathwayFormat];
      const fileUrl = `http://197.156.76.122/static/pathway/${filename}`;

      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const openModal = (pathway) => {
    setSelectedPathway(pathway);
    window.scrollTo(0, 0);
  };

  const closeModal = () => {
    setSelectedPathway(null);
  };

  return (
    <div className="pathway-container">
       {/* 🔙 Back to Home (ADD THIS HERE) */}
	    <button 
	      className="back-button"
	      onClick={() => navigate('/')}
	    >
	      <FaArrowLeft /> Back to Home
	    </button>
      {!selectedPathway ? (
        <>
          {/* ---------- HEADER ---------- */}
          <div className="pathway-header">
            <h2>Pathway List ({totalCount})</h2>

          </div>

          {/* ---------- CONTENT + SIDEBAR ---------- */}
          <div className="content-wrapper">
            <div className="pathway-main">
              {loading && <p>Loading pathways...</p>}
              {!loading && pathways.length === 0 && <p>No pathways found.</p>}

              {!loading &&
                pathways.map((pw, idx) => (
                  <div
                    key={pw.accession || idx}
                    className="pathway-card"
                    onClick={() => openModal(pw)}
                    style={{ cursor: 'pointer' }}
                  >
                    <h3>{pw.title || 'Untitled Pathway'}</h3>
                    <p><strong>Accession:</strong> {pw.accession || 'N/A'}</p>
                    <p><strong>Data Source:</strong> {pw.source_name || 'N/A'}</p>
                    <p><strong>External ID:</strong> {pw.external_id || 'N/A'}</p>
                    <p><strong>Taxonomy:</strong> {pw.taxonomy || 'N/A'}</p>
                    <p><strong>Type:</strong> {pw.taxonomic_scope || 'N/A'}</p>
                  </div>
                ))}

              {!loading && totalPages > 1 && (
                <div className="pagination">
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                  >
                    ⬅ Prev
                  </button>
                  <span>Page {currentPage} of {totalPages}</span>
                  <button
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                  >
                    Next ➡
                  </button>
                </div>
              )}
            </div>

            <div className="pathway-sidebar">
              <RightSidebar />
            </div>
          </div>
        </>
      ) : (
        /* ---------- FULL PAGE MODAL VIEW ---------- */
        <div className="pathway-fullpage">
          <div className="pathway-fullpage-content">
            <button className="back-btn" onClick={closeModal}>← Back</button>

            <h2>
              {selectedPathway.accession} - {selectedPathway.title}
            </h2>

            <div className="pathway-info">
              <p><strong>Record Type:</strong> Pathway</p>
              <p><strong>Accession:</strong> {selectedPathway.accession}</p>
              <p><strong>Title:</strong> {selectedPathway.title}</p>

              <p>
                <strong>External URL:</strong>{' '}
                <a
                  href={selectedPathway.external_url || '#'}
                  target="_blank"
                  rel="noreferrer"
                >
                  {selectedPathway.external_url || 'N/A'}
                </a>
              </p>

              <p>
                <strong>Source Name:</strong>{' '}
                <a
                  href={selectedPathway.source_url || '#'}
                  target="_blank"
                  rel="noreferrer"
                >
                  {selectedPathway.source_name || 'N/A'}
                </a>
              </p>

              <p>
                <strong>External ID:</strong>{' '}
                <a
                  href={selectedPathway.external_id_url || '#'}
                  target="_blank"
                  rel="noreferrer"
                >
                  {selectedPathway.external_id || 'N/A'}
                </a>
              </p>

              <p><strong>Taxonomic Scope:</strong> {selectedPathway.taxonomic_scope || 'N/A'}</p>

              <p>
                <strong>Taxonomy:</strong>{' '}
                <a
                  href={selectedPathway.taxonomy_url || '#'}
                  target="_blank"
                  rel="noreferrer"
                >
                  {selectedPathway.taxonomy || 'N/A'}
                </a>
              </p>

              <p><strong>Category:</strong> {selectedPathway.category || 'pathway'}</p>
              
              <p><strong>Record Description:</strong> {selectedPathway.record_description || 'N/A'}</p>
            </div>

            <div className="related-links">
              <h3>🔗 Related Links</h3>
              <a href={selectedPathway.external_url} target="_blank" rel="noreferrer">
                PubChem Substance
              </a>
              <a href={selectedPathway.source_url} target="_blank" rel="noreferrer">
                PubChem Source
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PathwayComponent;

